import React from "react";
import { useTranslation } from "react-i18next";

import cx from "classnames";

import { Select, MenuItem } from "@mui/material";

import { formatName } from "utility/formatName";

import styles from "./Columns.less";

export default function Columns(props) {
  const { t } = useTranslation();
  const filterDeactivated = props.fields.filter((field) => !field.deletedAt);

  return (
    <header className={styles.TableHeader} style={props.style}>
      <span className={styles.wrap}>
        {props.cols.map((col, index) => {
          // Handles empty columns
          const colName = `${formatName(col)}-${index}`;
          return (
            <div key={index} className={styles.column}>
              <span className={cx(styles.Cell)}>{col.toUpperCase()}</span>
              <Select
                name={colName}
                value={props.fieldMaps[col] || "none"}
                onChange={(evt) => {
                  props.handleMap(evt.target.value, col);
                }}
                size="small"
              >
                <MenuItem value="none">{t("content.csvImportNone")}</MenuItem>
                {filterDeactivated.map((field) => (
                  <MenuItem key={field.name} value={field.name}>
                    {field.label}
                  </MenuItem>
                ))}
              </Select>
            </div>
          );
        })}
      </span>
    </header>
  );
}
